import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { LanguageService } from '../../core/service/language.service';

@Injectable()
export class IdNumberValidatorService {
  constructor(private _languageService: LanguageService) {}
  private _validateSwedishSSN(ssn): boolean {
    if (!ssn || ssn.length == 0) return true;

    if (!ssn.match(/^(\d{2})?\d{6}-\d{4}$/)) return false;

    ssn = ssn
      .replace(/\D/g, '') // strip out all but digits
      .split('') // convert string to array
      .reverse() // reverse order for Luhn
      .slice(0, 10); // keep only 10 digits (i.e. 1977 becomes 77)

    // verify we got 10 digits, otherwise it is invalid
    if (ssn.length != 10) {
      return false;
    }

    var sum = ssn
      // convert to number
      .map(function (n) {
        return Number(n);
      })
      // perform arithmetic and return sum
      .reduce(function (previous, current, index) {
        // multiply every other number with two
        if (index % 2) current *= 2;
        // if larger than 10 get sum of individual digits (also n-9)
        if (current > 9) current -= 9;
        // sum it up
        return previous + current;
      });
    // sum must be divisible by 10
    return 0 === sum % 10;
  }

  private _validateIso8601(id): boolean {
    if (!id || id.length == 0) return true;

    if (!id.match(/^(\d{8})$/)) return false;

    let year = Number.parseInt(id.substring(0, 4));
    let month = Number.parseInt(id.substring(4, 2));
    let day = Number.parseInt(id.substring(6, 2));
    let date = new Date(year, month - 1, day);
    return !isNaN(date.getTime());
  }

  swedishSSN: ValidatorFn = (c: AbstractControl) => {
    return this._validateSwedishSSN(c.value) ? null : { swedishSSN: { message: 'ERROR.CIVIC_NUMBER' } };
  };

  swedishOrganizationNumber: ValidatorFn = (c: AbstractControl) => {
    return this._validateSwedishSSN(c.value) ? null : { swedishSSN: { message: 'ERROR.ORGANIZATION_NUMBER' } };
  };

  birthdayIso8601: ValidatorFn = (c: AbstractControl) => {
    return this._validateIso8601(c.value)
      ? null
      : {
          birthdayIso8601: {
            message: 'ERROR.FORMAT_PRM',
            params: { 0: this._languageService.getText('TENANT.ID_TYPE.FORMAT.F200') },
          },
        };
  };
}
